import logo from './logo.svg';
import './App.css';
import {Header} from "./components/Header/Header";
import {Fs} from "./components/first-section/fs";
import {CountContext} from "./CountContext";
import {useState} from "react";
import {ImagePopup} from "./components/first-section/imagePopup";
import {AiOutlineShoppingCart} from "react-icons/ai";
import React from "react";
import art1 from "./images/image-product-1.jpg";
import art2 from "./images/image-product-2.jpg";
import art3 from "./images/image-product-3.jpg";
import art4 from "./images/image-product-4.jpg";
import './components/first-section/fs.scss';
import art1Th from './images/image-product-1-thumbnail.jpg';
import art2Th from './images/image-product-2-thumbnail.jpg';
import art3Th from './images/image-product-3-thumbnail.jpg';
import art4Th from './images/image-product-4-thumbnail.jpg';
import {useContext} from "react";

function App() {
    const [count, setCount] = useState(0);
    if (count < 0){
        setCount(0)
    }
    const [buttonPopup, setButtonPopup] = useState(false);
    const hoverHandler = (image, i) => {
        setImg(image)
    }
    const images = [
        art1,
        art2,
        art3,
        art4
    ];
    const [img, setImg] = useState(images[0]);





    function toogle() {
        let blur = document.getElementById('blur');
        blur.classList.toggle('active')
    }

    return (
    <>

        <CountContext.Provider value={{count, setCount}}>
            <Header />
            <section className="first-section">

                <div className="container">
                    <ImagePopup trigger={buttonPopup} setTrigger={setButtonPopup} img={img} setImg={setImg}>

                    </ImagePopup>
                    <div className="left">
                        <div className="image1" >
                            <img src={img} alt="img" className="img1" onClick={function() {
                                toogle();
                                setButtonPopup(true);
                            }} />

                        </div>
                        <div className="img-grid" >
                            {images.map((image, i) => (
                                <img src={image} alt="" key={i} onMouseOver={() => hoverHandler(image, i)} />
                            ))}
                        </div>
                    </div>

                    <div className="right">
                        <small>SNEAKER COMPANY</small>
                        <h1>Fall Limited Edition <br></br> Sneakers </h1>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque aut error necessitatibus numquam quo? Architecto laborum quam quo vel velit.</p>

                        <h2>$125.00  <span className="reduc">50%</span> <br></br>
                            <small className="oldPrice">$250.00</small>
                        </h2>


                        <div className="right-btn">
                            <div className="number">
                                <button onClick={() => setCount(count - 1)}>-</button>
                                <span>{count}</span>
                                <button onClick={() => setCount(count + 1)}>+</button>
                            </div>

                            <div className="addCart">
                                <AiOutlineShoppingCart className="cart-icon" />
                                <button onClick={() => setCount(count)}>Add to cart</button>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </CountContext.Provider>
    </>



  );
}

export default App;
